import React from 'react';
import { Chip } from '@mui/material';
import { STATUS_CHIP_STYLES } from '../theme/kiff';

/** "pending" -> "PENDING", "in_progress" -> "IN PROGRESS". */
const label = (status) => String(status || '').replace(/_/g, ' ').toUpperCase();

/**
 * The booking lifecycle chip — the one visual for the six states, used
 * everywhere a booking status appears so owners learn the colour language
 * once. Tinted fill, 1.5px border drawn in the text colour (AA on every
 * fill); cancelled strikes its label through.
 *
 * `suffix` appends detail into the same pill: <BookingStatusChip
 * status="pending" suffix="3H" /> renders "PENDING · 3H".
 */
export default function BookingStatusChip({ status, suffix, size = 'small', sx, ...rest }) {
  const styles = STATUS_CHIP_STYLES[status] || STATUS_CHIP_STYLES.completed;

  return (
    <Chip
      size={size}
      label={suffix ? `${label(status)} · ${suffix}` : label(status)}
      sx={{ ...styles, ...sx }}
      {...rest}
    />
  );
}
